import { getDateTz } from '@airship-platform/airship-patterns';
import { useEffect } from 'react';
import { useAppointmentHistory } from '../../../data-access/appointmentHistory';
import { useAppointments } from '../../../data-access/appointments';
import ProposalTemplateOptionQueryResults from './ProposalTemplatesHistoryQueryResults';

const ProposalTemplatesHistoryQuery: React.FC = () => {
  const { fetchAppointmentHistory } = useAppointmentHistory();
  const { currentAppointment } = useAppointments();

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const startDate = getDateTz(year, month - 3, 1)();
    const endDate = getDateTz(year, month, 1)();

    const businessUnitIds = currentAppointment?.job.businessUnitId
      ? [currentAppointment.job.businessUnitId]
      : undefined;

    const abortController = new AbortController();
    fetchAppointmentHistory(
      {
        status: ['COMPLETED'],
        startDateTime: startDate.toISOString(),
        endDateTime: endDate.toISOString(),
        businessUnitIds,
      },
      { signal: abortController.signal }
    );

    return () => {
      !abortController.signal.aborted &&
        abortController.abort('ProposalTemplatesHistoryQuery unmounted');
    };
  }, [fetchAppointmentHistory, currentAppointment?.job.businessUnitId]);

  return <ProposalTemplateOptionQueryResults />;
};

export default ProposalTemplatesHistoryQuery;
